<div id="main-container" class="col-md-4 gradientBg">
  <span id="CHCCFoundation"></span>
</div>

<div id="questionLists" class="col-md-10 mt-5">
  <div class="row">
    <div class="col-md-12">
      <p>
        The CHCCF was created and incorporated in 2008 and is a 501(c) (3)
        nonprofit public benefit corporation. The Foundation was established to
        identify funding opportunities for the educational and economic
        development programs of the CHCCF and supported organizations.
      </p>
      <p>
        <strong>Mission:</strong>
        “To create, develop and provide education and economic development
        programs to increase leadership for CHCC and for its members.”
      </p>
    </div>

    <p class="mt-2">
      The primary charitable purposes of the CHCC Foundation are:
    </p>
    @for (list of lists; track list) {
      <div class="col-md-12 pb-3">
        <ul>
          <p>
            <li>{{ list.text1 }}</li>
            <li>{{ list.text2 }}</li>
            <li>{{ list.text3 }}</li>
          </p>
        </ul>
      </div>
    }
  </div>

  <div id="ExecutiveCommittee">
    <h2 class="pb-5" style="text-transform: uppercase">Executive Committee</h2>
    <div class="row pb-5">
      @for (picture of pictures; track picture) {
        <div
          class="col-6 col-md-6 col-lg-4 pb-5"
          >
          <img
            src="{{ picture.img }}"
            class="img-fluid circle"
            alt="{{ picture.alt }}"
            />
            <div class="col-sm-12 mt-3">
              <p class="mt-2">
                <strong>{{ picture.name }}</strong>
                <br />
                <b>{{ picture.title }}</b>
                <br />
                {{ picture.description }}
                <br />
                {{ picture.city }}
              </p>
            </div>
          </div>
        }
      </div>
    </div>

    <div id="BoardofDirectors">
      <h2 class="pb-5" style="text-transform: uppercase">BOARD OF DIRECTORS</h2>
      <div class="row pb-5">
        @for (director of directors; track director) {
          <div
            class="col-6 col-md-6 col-lg-4 pb-5"
            >
            <img
              src="{{ director.img }}"
              class="img-fluid circle"
              alt="{{ director.alt }}"
              />
              <div class="col-sm-12 mt-3">
                <p class="mt-2">
                  <strong>{{ director.name }}</strong>
                  <br />
                  <b>{{ director.title }}</b>
                  <br />
                  {{ director.description }}
                  <br />
                  {{ director.city }}
                </p>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
